<template>
    <div class="manager-settings">
        <div class="saving-strip" v-if="saveSpinner">
            {{ translate('saving') }}
            <b-spinner style="width: 10px; height: 10px;" type="grow" label="Spinning"></b-spinner>
        </div>
        <customModalDialog :settings="customModalSettings"></customModalDialog>
        <w3wPopup :settings="w3wPopupSettings"></w3wPopup>
        <telegramBotPopup :settings="telegramBotPopupSettings"></telegramBotPopup>
        <div class="returnBtn__wrapper" @click="returnToMain">
            <div class="returnBtn__icon">
                <img src="@/assets/icons/Menager_back_arrow.svg">
            </div>
            <div class="returnBtn__text">{{translate('ReturnBtn')}}</div>
        </div>
        <h2 class="title">{{translate('accountSettings')}}</h2>
        <div class="top-bar">
            <p>{{translate('accountSettingsDescription')}}</p>
        </div>

        <div class="dropdown-content">
            <ul>
                <li class="item">
                    <div class="item__wrapper">
                            <div class="title">
                                <div class="title__wrapper">
                                    <img src="@/assets/icons/profile_settings_icon.svg">
                                    <div>
                                        <div class="settings-title">
                                            <span>{{translate('ProfileSettings')}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="edit__btn" @click="dropdown.profile = !dropdown.profile"
                                    :class="{active: dropdown.profile}">
                                    <img src="@/assets/icons/icon_settings_edit.svg" class="edit__btn-icon">
                                    <div class="edit__btn-text">{{translate('bi_Edit')}}</div>
                                </div>
                            </div>
                            <transition name="component-fade" mode="out-in">
                                <div v-if="dropdown.profile" class="content">
                                <div class="profile-section">
                                    <div class="photo-section">
                                        <div class="button-group" v-if="false">
                                            <button class="primaryButton">
                                                <img src="@/assets/icons/ic_upload.svg" alt="">
                                                <span>{{translate('UploadNewPhoto')}}</span>
                                            </button>
                                            <button class="primaryButton reverse">
                                                <img src="@/assets/icons/icon_trash.svg" alt="">
                                                <span>{{translate('Remove')}}</span>
                                            </button>

                                        </div>
                                    </div>
                                    <div class="input-section">
                                        <div class="name">
                                            <md-field :class="{'md-invalid': $v.profile.firstName.$dirty && $v.profile.firstName.$invalid}">
                                                <label>{{translate('bi_first_Name')}}</label>
                                                <md-input
                                                        v-model="profile.firstName"
                                                        :maxlength="100"
                                                        type="text"
                                                        @input="checkValidation">
                                                </md-input>
                                                <span class="md-error">{{translate('ThereIsAnError')}}</span>
                                            </md-field>

                                            <md-field>
                                                <label>{{translate('bi_last_Name')}}</label>
                                                <md-input
                                                        v-model="profile.lastName"
                                                        :maxlength="100"
                                                        type="text">
                                                </md-input>
                                                <span class="md-error">{{translate('ThereIsAnError')}}</span>
                                            </md-field>
                                        </div>
                                        <div class="mail">
                                            <md-field :class="{'md-invalid': $v.profile.email.$dirty && $v.profile.email.$invalid}">
                                                <label>{{translate('bi_ContactEmail')}}</label>
                                                <md-input
                                                        v-model="profile.email"
                                                        :maxlength="100"
                                                        type="email"
                                                        @input="checkValidation">
                                                </md-input>
                                                <span class="md-error">{{translate('ThereIsAnError')}}</span>
                                                <div v-if="userInfo.is_verified == false">
                                                    <div class="email-verified__wrapper">
                                                        <img class="email-verified__icon" src="@/assets/icons/ic_exclamation-red.svg">
                                                        <div class="email-verified__text">{{translate('bi_confirm_email')}}</div>
                                                    </div>
                                                </div>
                                            </md-field>
                                            <div class="email-resend__btn" @click="resendEmailAction"
                                            v-if="userInfo.is_verified == false">
                                                {{translate('bi_resend_email')}}
                                            </div>
                                        </div>
                                        <div class="phone">
                                            <md-field
                                                    ref="phoneField"
                                                    :class="{'md-invalid': $v.profile.phone.$dirty && $v.profile.phone.$invalid}"
                                                    class="active phone-custom md-has-value"

                                            >
                                                <label>{{translate('bi_Phone')}}</label>
                                                <vue-tel-input
                                                        id="tooltip-phone"
                                                        v-model="profile.phone"
                                                        placeholder=""
                                                        :inputOptions="{showDialCode: true}"
                                                        @input="onInputPhoneField"
                                                        @blur="onBlurPhoneField"
                                                ></vue-tel-input>
                                                <span class="md-error">{{ translate('bi_validation_Phone') }}</span>
                                                <!--                                    <b-tooltip target="tooltip-phone" variant="info">Ex: +38 050 777-77-77</b-tooltip>-->
                                            </md-field>
                                        </div>
                                        <div class="short-info__password-wrapper" @click="passwordModal = true">
                                            <div class="short-info__title">{{translate('bi_Password')}}</div>
                                            <div class="password-change" v-if="userInfo.has_password">
                                                {{translate('bi_change_password')}}
                                            </div>
                                            <div v-else class="password-change">
                                                {{translate('bi_set_password')}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </transition>
                            <transition name="component-fade" mode="out-in">
                                <div v-if="!dropdown.profile" class="short-info">
                                    <div class="short-info__first">
                                        <div class="first-name__wrapper">
                                            <div class="short-info__title">{{translate('bi_first_Name')}}: </div>
                                            <div class="first-name">
                                                <div>{{profile.firstName}}</div>
                                            </div>
                                        </div>
                                        <div class="last-name__wrapper">
                                            <div class="short-info__title">{{translate('bi_last_Name')}}: </div>
                                            <div class="last-name">
                                                <div>{{profile.lastName}}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="short-info__email-wrapper">
                                        <div class="short-info__title">{{translate('bi_ContactEmail')}}</div>
                                        <div class="short-info__email-content">
                                            <div v-if="profile.email" class="short-info__email">
                                                <a :href="'mailto:'+profile.email">
                                                    {{profile.email}}
                                                </a>
                                            </div>
                                            <div v-if="userInfo.is_verified == false">
                                                <div class="email-verified__check">
                                                    <img class="email-check__icon" src="@/assets/icons/ic_exclamation-red.svg">
                                                    <div class="email-check__text">{{translate('bi_confirm_email')}}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="email-resend__btn" @click="resendEmailAction"
                                             v-if="userInfo.is_verified == false">
                                             {{translate('bi_resend_email')}}
                                        </div>
                                    </div>
                                    <div v-if="profile.phone" class="short-info__phone-wrapper">
                                        <div class="short-info__title">{{translate('bi_Phone')}}</div>
                                        <div class="short-info__phone">
                                            <a :href="'tel:'+profile.phone">{{profile.phone}}</a>
                                        </div>
                                    </div>
                                    <div class="short-info__password-wrapper" @click="passwordModal = true">
                                        <div class="short-info__title">{{translate('bi_Password')}}</div>
                                        <div class="password-change">
                                            <div v-if="this.userInfo.has_password">{{translate('bi_change_password')}}</div>
                                            <div v-else> {{translate('bi_set_password')}} </div>
                                        </div>
                                    </div>
        <!--                        <div class="grid">-->
        <!--                            <div>{{translate('bi_Name')}}: </div>-->
        <!--                            <div>{{profile.firstName}} {{profile.lastName}}</div>-->
        <!--                            <div v-if="profile.email">{{translate('bi_ContactEmail')}}: </div>-->
        <!--                            <div v-if="profile.email">-->
        <!--                                <a :href="'mailto:'+profile.email">-->
        <!--                                    {{profile.email}}-->
        <!--                                </a>-->
        <!--                            </div>-->
        <!--                            <div v-if="profile.phone">{{translate('bi_Phone')}}: </div>-->
        <!--                            <div v-if="profile.phone">-->
        <!--                                <a :href="'tel:'+profile.phone">{{profile.phone}}</a>-->
        <!--                            </div>-->
        <!--                        </div>-->
                                </div>

                            </transition>
                        </div>
                    <div class="save__wrapper" v-if="dropdown.profile">
                            <div class="save__content">
                                <div class="content__save-btn" @click="updateProfileInfo">
                                    {{translate('Save')}}
                                </div>
                            </div>
                        </div>
                </li>
                <li class="item">
                    <div class="item__wrapper">
                        <div class="title">
                            <div class="title__wrapper">
                                <img src="@/assets/icons/alert_settings_icon.svg" class="alert__image">
                                <div class="notification__content">
                                    <h3>
                                        <span>{{translate('Notifications')}}</span>
                                    </h3>
                                    <div class="notification__wrapper">
                                        <span class="description">{{translate('receiveBadVotesViaSms')}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <transition name="component-fade" mode="out-in">
                            <div class="content">
                                <div class="notificationBtn active-field" :class="{'dropdown-notification__checkbox' : !dropdown.notification}">
                                    <b-form-checkbox v-model="profile.disableNotifications" @input="updateProfileAlerts" >
                                        <span class="notificationBtn__text">{{translate('DisableAllNotifications')}}</span>
                                    </b-form-checkbox>
                                </div>
                            <div class="grid notification-section" :class="{'disable-notification': !(dropdown.notification && !profile.disableNotifications)}">
                                <div class="blocks-divider"></div>
                                <div class="report-title__wrapper">
                                    <div class="report-title">{{translate('Channel')}}</div>
                                </div>
                                <div class="active-field">
                                    <b-form-checkbox v-model="profile.checkboxSms" @input="updateProfileAlerts">
                                        <span>{{translate('SMS')}}</span>
                                    </b-form-checkbox>
                                    <b-form-checkbox v-model="profile.checkboxEmail" @input="updateProfileAlerts">
                                        <span>{{translate('Email')}}</span>
                                    </b-form-checkbox>
                                    <b-form-checkbox v-model="profile.checkboxTelegram" @input="updateProfileAlerts">
                                        <span>Telegram</span>
                                    </b-form-checkbox>
                                    <div class="setup_telegram" v-if="profile.checkboxTelegram" @click="setupTelegramBotClick">
                                        {{translate('setupTelegramBtn')}}
                                    </div>
                                </div>
                                <b-form-checkbox v-model="profile.smsExpanded" @input="updateProfileAlerts" v-if="signedInByAdmin() && profile.checkboxSms">
                                    <span>Expanded SMS Ⓐ</span>
                                </b-form-checkbox>
                                <div class="blocks-divider"></div>
                                <div class="alert-title__wrapper">
                                    <div class="report-title">{{translate('sendAlertEvery')}}</div>
                                </div>
                                <div class="active-field">
                                    <div class="active-field__wrapper">
                                        <div class="input__wrapper" v-if="dropdown.notification">
                                            <input class="active-field__number active" min="0" v-model="profile.SendNotificationEach"
                                                   type="number" @input="profile.SendNotificationEach < 0 ? profile.SendNotificationEach = 0 : null">
                                            <span>{{translate('SendNotificationEach2')}}</span>
                                        </div>
                                            <div class="sendNotification-string" v-else>{{profile.SendNotificationEach}} {{translate('SendNotificationEach2')}}</div>
                                        <div class="active-field__checkbox-list">
                                            <b-form-checkbox v-model="profile.checkboxHappy" @input="updateProfileAlerts" class="cb-generic">
                                                <span>"{{translate('checkboxHappy')}}"</span>
                                            </b-form-checkbox>
                                            <b-form-checkbox v-model="profile.checkboxSoSo" @input="updateProfileAlerts" class="cb-generic">
                                                <span>"{{translate('checkboxSoSo')}}"</span>
                                            </b-form-checkbox>
                                            <b-form-checkbox v-model="profile.checkboxSad" @input="updateProfileAlerts" class="cb-generic">
                                                <span>"{{translate('checkboxSad')}}"</span>
                                            </b-form-checkbox>
                                        </div>
                                    </div>
                                </div>
                                <div class="additional_checkboxes">

                                    <b-form-checkbox v-model="profile.detailsOnly" @input="onWithDetailsOnlyClick">
                                        <span>{{translate('WithDetailsOnly')}}</span>
                                    </b-form-checkbox>
                                    <span class="description description_details_only" v-if="profile.detailsOnly">Alert me if any of these apply</span>
                                    <div class="description_checkbox-list" v-if="profile.detailsOnly">
                                        <div class="ra-select-all-wrapper">
                                            <div @click="onRateAnalyzeChangeAllClick(true)" class="ra-select-all" v-if="!raAllSelected">Select all</div>
                                            <div @click="onRateAnalyzeChangeAllClick(false)" class="ra-select-all" v-if="raAllSelected">Unselect all</div>

                                        </div>
                                        <div v-for="(item, index) in profile.rateAnalyzeGroups" :key="item.id"
                                        class="ai_group_cbs">
                                            <b-form-checkbox v-model="item.selected"
                                                             @input.native="onRateAnalyzeItemCheckChanged(item, $event)" class="cb-generic">
                                                <span>{{ item.name }}</span>
                                            </b-form-checkbox>
                                            <div class="ai_group_important"
                                                 :class="{selected: item.high_priority}"
                                                 v-if="item.selected"
                                                 @click="onRAImportantClick(item)"
                                            ><div class="excl">!</div><div class="lbl">high priority</div></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="blocks-divider"></div>
                                <div class="additional_checkboxes">
                                    <b-form-checkbox v-model="profile.checkboxServiceLog" @input="updateProfileAlerts">
                                        <span>Service log alerts</span>
                                    </b-form-checkbox>
                                    <b-form-checkbox v-model="profile.checkboxDumpsters" @input="updateProfileAlerts" v-if="profile.checkboxDumpstersShow">
                                        <span>Dumpster alerts</span>
                                    </b-form-checkbox>
                                    <b-form-checkbox v-model="profile.checkboxGreasetraps" @input="updateProfileAlerts" v-if="profile.checkboxGreasetrapsShow">
                                        <span>Greasetrap alerts</span>
                                    </b-form-checkbox>
                                    <b-form-checkbox v-model="profile.checkboxGoogleReviewAlerts" @input="updateProfileAlerts" v-if="profile.checkboxGoogleReviewAlertsShow">
                                        <span>{{translate('settings_checkbox_GoogleReviewAlerts')}}</span>
                                    </b-form-checkbox>
                                </div>
                            </div>
                        </div>
                        </transition>
                    </div>
                </li>
                <li class="item">
                    <div class="item__wrapper">
                        <div class="title">
                            <div class="title__wrapper">
                                <img src="@/assets/icons/calendar_settings_icon.svg" class="alert__image">
                                <div class="notification__content">
                                    <h3>
                                        <span>Shifts</span>
                                    </h3>
                                    <div class="notification__wrapper">
                                        <span class="description">Customize time for alerting</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="content">
                            <div class="tz-selector-wrapper">
                                <div class="lbl">Time zone</div>
                                <timeZoneSelector class="tz-selector" @onTimeZoneChanged="onTimeZoneChangedSettings" :timezone="profile.timezone"/>
                            </div>
                            <div class="notificationBtn active-field customized-alerting-cb">
                                <b-form-checkbox v-model="profile.shiftsEnabled">
                                    <span class="notificationBtn__text">Enable customized alerting</span>
                                </b-form-checkbox>
                                <b-form-checkbox v-model="profile.shiftsDetailed" v-if="profile.shiftsEnabled" @change="onDetailedCustomizationCheckboxBeforeChanged">
                                    <span class="notificationBtn__text">Detailed customization</span>
                                </b-form-checkbox>
                            </div>
                            <div v-if="profile.shiftsEnabled && !profile.shiftsDetailed">
                                <div class="blocks-divider"></div>
                                <div class="time-selector-wrapper">
                                    <date-picker
                                        name="date"
                                        v-model="profile.shiftsSimple.from_time"
                                        :config="timePickerOptions"
                                        class="time-selector"
                                        @dp-hide="onShiftFromTimeSelectorHidden()"
                                        @dp-change="onShiftFromTimeChanged()"
                                    ></date-picker>
                                    <span class="shift-arrow">-></span>
                                    <date-picker
                                        name="date"
                                        v-model="profile.shiftsSimple.to_time"
                                        :config="timePickerOptions"
                                        class="time-selector"
                                        @dp-hide="onShiftToTimeSelectorHidden()"
                                        @dp-change="onShiftToTimeChanged()"
                                    ></date-picker>
                                </div>
                                <div class="simple-shifts-wrapper">
                                    <div v-for="(dow, index) in profile.shiftsSimple.dows" class="dow-shift-item">
                                        <b-form-checkbox v-model="dow.enabled">
                                            <span class="notificationBtn__text">{{dow.label}}</span>
                                        </b-form-checkbox>
                                    </div>
                                </div>
                                <div class="blocks-divider"></div>
                            </div>
                            <div v-if="profile.shiftsEnabled && profile.shiftsDetailed">
                                <div class="blocks-divider"></div>
                                <div class="shifts-wrapper">
                                    <div v-for="(shift, index) in profile.shifts" class="shift-item">
                                        <div class="block-icon" v-if="false">
                                            <div class="ic-block-action" v-if="index != 0" @click="onMoveShiftUpClick(shift, index)">
                                                <img src="@/assets/icons/icon_grey-up.svg" alt="">
                                            </div>
                                            <div class="empty" v-else />
                                            <div class="ic-block-action"
                                                 v-if="index != (profile.shifts.length-1)"
                                                  @click="onMoveShiftDownClick(shift, index)">
                                                <img src="@/assets/icons/icon_grey-down.svg" alt="">
                                            </div>
                                            <div class="empty" v-else />
                                        </div>
                                        <model-select v-model="shift.from_dow"
                                                      :options="dows"
                                                      class="dow-selector"
                                                      placeholder="choose day">
                                        </model-select>
                                        <date-picker
                                            name="date"
                                            v-model="shift.from_time"
                                            :config="timePickerOptions"
                                            class="time-selector"
                                            @dp-hide="onShiftFromTimeSelectorHidden(shift)"
                                            @dp-change="onShiftFromTimeChanged(shift)"
                                        ></date-picker>
                                        <span class="shift-arrow">-></span>
                                        <model-select v-model="shift.to_dow"
                                                      :options="dows"
                                                      class="dow-selector"
                                                      placeholder="choose day">
                                        </model-select>
                                        <date-picker
                                            name="date"
                                            v-model="shift.to_time"
                                            :config="timePickerOptions"
                                            class="time-selector"
                                            @dp-hide="onShiftToTimeSelectorHidden(shift)"
                                            @dp-change="onShiftToTimeChanged(shift)"
                                        ></date-picker>
                                        <div class="shift-remove" @click="onShiftRemoveClick(shift)">
                                            <img src="@/assets/icons/ic_remove_shift.svg"/>
                                        </div>
                                    </div>
                                </div>
                                <div class="add-shift"
                                     v-if="this.profile.shifts.length < this.shiftsMaxCount"
                                     @click="onShiftAddClick">Add</div>
                                <div class="blocks-divider"></div>
                            </div>
                            <div class="shifts-btns">
                                <div class="save-shifts" @click="onShiftsSaveClick">Save</div>
<!--                                    <div class="reset-shifts" @click="onShiftsResetClick">Reset</div>-->
                            </div>
                        </div>
                    </div>
                </li>

                <li class="item">
                    <div class="item__wrapper">
                        <div class="title">
                            <div class="title__wrapper">
                                <img src="@/assets/icons/report_settings_icon.svg" class="report__image">
                                <div>
                                    <h3>
                                        <span>{{translate('Reports')}}</span>
                                    </h3>
                                    <span class="description">{{translate('sendDetailedReportToEmail')}}</span>
                                </div>
                            </div>
                        </div>
                        <transition name="component-fade" mode="out-in">
                            <div class="report-content">
                            <div class="grid notification-section" :class="{'disable-notification': !dropdown.reports}">
                                <div>
                                    <div class="report-title">{{translate('Regularity')}}</div>
                                </div>
                                <div class="active-field">
                                    <label>
                                        <b-form-checkbox v-model="profile.dailyReports"  @input="updateProfileReports">
                                            <span>{{translate('daily')}}</span>
                                        </b-form-checkbox>
                                    </label>
                                    <label>
                                        <b-form-checkbox v-model="profile.weeklyReports" @input="updateProfileReports">
                                            <span>{{translate('weekly')}}</span>
                                        </b-form-checkbox>
                                    </label>
                                    <label>
                                        <b-form-checkbox v-model="profile.monthlyReports" @input="updateProfileReports">
                                            <span>{{translate('monthly')}}</span>
                                        </b-form-checkbox>
                                    </label>
                                </div>
                            </div>
                        </div>
                        </transition>
                    </div>
                </li>
                <li class="item">
                    <div class="item__wrapper other_settings">
                        <div class="title">
                            <div class="title__wrapper">
                                <img src="@/assets/icons/ic_tune.svg" class="report__image">
                                <div>
                                    <h3>
                                        <span>{{translate('otherOptions')}}</span>
                                    </h3>
                                </div>
                            </div>
                        </div>
                        <transition name="component-fade" mode="out-in">
                            <div class="report-content no_subtitle-content">
                                <div class="active-field other">
                                    <b-form-checkbox v-model="profile.showZeroVotes" @input="updateProfileAnalytic" class="settings-cb">
                                        <span>{{translate('own_ShowZeroVotes')}}</span>
                                    </b-form-checkbox>
                                    <div class="w3w__checkbox">
                                        <b-form-checkbox v-model="profile.useW3W" @input="updateProfileAnalytic" class="settings-cb">
                                            <span>{{translate('own_use_w3w')}}</span>
                                        </b-form-checkbox>
                                        <div class="w3w__info" @click="showW3Wpopup">
                                            <img src="@/assets/icons/w3w_info.svg">
                                        </div>
                                    </div>
                                    <div class="unassigned-question">
                                        <b-form-checkbox v-model="profile.filterUnassignedQuestions" @input="updateProfileAnalytic" class="settings-cb">
                                            <span>{{translate('unassignedQuestion')}}</span>
                                        </b-form-checkbox>
                                    </div>
                                </div>
                                <div @click="onCloseAccount">
                                    <div class="def-btn">
                                        <span
                                                :variant="userInfo.deletion ? 'warning' : 'secondary'"
                                        >
                                            {{translate(userInfo.deletion ? 'RestoreAccount' : 'CloseAccount')}}
                                        </span>
                                    </div>
                                </div>
                                <div @click="logout">
                                    <div class="def-btn">
                                        {{translate('Logout')}}
                                    </div>
                                </div>
                        </div>
                        </transition>
                    </div>
                </li>
                <li class="item" v-if="this.profile.croIntegrationShow || this.profile.hubspotIntegrationShow">
                    <div class="item__wrapper other_settings">
                        <div class="title">
                            <div class="title__wrapper">
                                <img src="@/assets/icons/ic_integration.svg" class="report__image">
                                <div>
                                    <h3>
                                        <span>{{translate('settings_integrations')}}</span>
                                    </h3>
                                </div>
                            </div>
                        </div>
                        <div class="report-content int_button" v-if="this.profile.croIntegrationShow">
                            <div @click="onCroClick">
                                <div class="def-btn">
                                    <img src="@/assets/icons/ic_cro.png" class="btn_image_">
                                        <span :variant="isCroLinked ? 'secondary' : 'warning'">
                                            {{translate(isCroLinked ? 'settings_unlink_cro' : 'settings_link_cro')}}
                                        </span>
                                </div>
                            </div>
                        </div>
                        <div class="report-content int_button" v-if="this.profile.hubspotIntegrationShow">
                            <div @click="onHubspotClick">
                                <div class="def-btn">
                                    <img src="@/assets/icons/ic_hubspot.png" class="btn_image_">
                                        <span :variant="isHubspotLinked ? 'secondary' : 'warning'">
                                            {{translate(isHubspotLinked ? 'settings_unlink_hubspot' : 'settings_link_hubspot')}}
                                        </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <div class="passwordModal">
                <div class="modal-overlay" :class="{'active': passwordModal}">
                    <div class="modal-window">
                        <div class="modalHeader">
                            <div class="modalHeader-title" v-if="this.userInfo.has_password">
                                {{translate('bi_change_password')}}
                            </div>
                            <div class="modalHeader-title" v-else>
                                {{translate('bi_set_password')}}
                            </div>
                            <div class="modalHeader-cross" @click="passwordModal = false">
                                <img src="@/assets/icons/ic_close_password_popup.svg">
                            </div>
                        </div>
                        <div class="modalBody">
                            <md-field class="password-custom md-has-password" v-if="this.userInfo.has_password">
                                <label>{{translate('bi_current_password')}}</label>
                                <md-input type="password" v-model="changePass.currentPassword">

                                </md-input>
                            </md-field>
                            <md-field class="password-custom md-has-password">
                                <label>{{translate('bi_new_password')}}</label>
                                <md-input type="password" v-model="changePass.newPassword"
                                          @focus="onPasswordFocus"
                                          @blur="onPasswordFocusLost"
                                          ></md-input>
                            </md-field>
                            <passwordValidation :settings='passwordValidationSettings'></passwordValidation>
                            <md-field class="password-custom md-has-password">
                                <label>{{translate('bi_retype_password')}}</label>
                                <md-input type="password" v-model="changePass.RetypeNewPassword">

                                </md-input>
                            </md-field>
                        </div>
                        <div class="modalFooter">
                            <div class="modalFooter-btn">
                                <div class="password__save-btn" @click="saveNewPassword(); passwordModal = false">
                                    {{translate('Save')}}
                                </div>
                                <div class="password__cansel-btn" @click="passwordModal = false, reloadFromProfile()">
                                    {{translate('Cancel')}}
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

    </div>
</template>

<script>

    import Vue from 'vue'
    import {MdField} from 'vue-material/dist/components'
    import '@/assets/css/MdField.css'
    import {validationMixin} from 'vuelidate'
    import {isPhoneValid, phoneValidator, emailValidator} from '@/helpers/customValidators'
    import {VueTelInput} from 'vue-tel-input'
    import errorMixin from '@/mixins/errorMixin';
    import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
    import customModalDialog from '@/components/widgets/customModalDialog';
    import passwordValidation from "@/components/widgets/passwordValidation";
    import logAnalyticsEvent, {logError} from '@/helpers/analytics';
    import w3wPopup from "@/components/widgets/w3wPopup";
    import telegramBotPopup from "@/components/widgets/telegramBotPopup"
    import timeZoneSelector from "@/components/widgets/timeZoneSelector";
    import { ModelSelect } from 'vue-search-select'
    import datePicker from "vue-bootstrap-datetimepicker";
    import moment from "moment";

    const {required, email} = require('vuelidate/lib/validators')

    Vue.use(MdField)

    export default {
        name: 'ProfileSettings',

        mixins: [errorMixin, validationMixin],

        validations: {
            profile: {
                firstName: {
                    required
                },
                phone: {
                    phone: phoneValidator
                },
                email: {
                    email: emailValidator
                }
            }
        },

        data() {
            return {
                customModalSettings: {},
                telegramBotPopupSettings: {},
                saveSpinner: false,
                saveDisable: false,
                isActive: false,
                passwordModal: false,
                changePass: {
                  currentPassword: '',
                  newPassword: '',
                    RetypeNewPassword: '',
                },
                dropdown: {
                  profile: true,
                  notification: true,
                  reports: true,
                  analytic: true,
                  analyticDescription: true
                },
                profile: {
                    firstName: '',
                    lastName: '',
                    email: '',
                    phone: '',
                    timezone: '',
                    detailsOnly: false,
                    checkboxSms: false,
                    checkboxEmail: false,
                    checkboxHappy: false,
                    checkboxSad: false,
                    checkboxSoSo: false,
                    checkboxServiceLog: false,
                    checkboxDumpsters: false,
                    checkboxDumpstersShow: false,
                    checkboxGreasetraps: false,
                    checkboxGreasetrapsShow: false,
                    checkboxGoogleReviewAlerts: false,
                    checkboxGoogleReviewAlertsShow: false,
                    croIntegrationShow: false,
                    hubspotIntegrationShow: false,
                    checkboxTelegram: false,
                    disableNotifications: true,
                    rateAnalyzeGroups: [],
                    smsExpanded: false,
                    enableAnalytic: true,
                    SendNotificationEach: 15,
                    dailyReports: false,
                    weeklyReports: false,
                    monthlyReports: false,
                    showZeroVotes: false,
                    useW3W: false,
                    filterUnassignedQuestions: false,
                    shiftsEnabled: true,
                    shiftsDetailed: false,
                    shiftsSetupInitial: {},
                    shifts: [
                        {
                            from_dow: 'mon',
                            from_time: '08:00',
                            to_dow: 'mon',
                            to_time: '17:00',
                        },
                        {
                            from_dow: 'tue',
                            from_time: '09:00',
                            to_dow: 'tue',
                            to_time: '18:00',
                        }
                    ],
                    shiftsSimple: {
                        from_time: '08:00',
                        to_time: '17:00',
                        dows: [
                            {
                                label: 'Monday',
                                value: 'mon',
                                enabled: true,
                            },
                            {
                                label: 'Tuesday',
                                value: 'tue',
                                enabled: true,
                            },
                            {
                                label: 'Wednesday',
                                value: 'wed',
                                enabled: true,
                            },
                            {
                                label: 'Thursday',
                                value: 'thu',
                                enabled: true,
                            },
                            {
                                label: 'Friday',
                                value: 'fri',
                                enabled: true,
                            },
                            {
                                label: 'Saturday',
                                value: 'sat',
                                enabled: false,
                            },
                            {
                                label: 'Sunday',
                                value: 'sun',
                                enabled: false,
                            },
                        ],
                    },
                },
                passwordValidationSettings: {
                    validation: '',
                    show: false,
                    dark: true,
                },
                w3wPopupSettings: {
                    show: false
                },
                dows: [
                    {
                        "value": "mon",
                        "text": "Monday"
                    },
                    {
                        "value": "tue",
                        "text": "Tuesday"
                    },
                    {
                        "value": "wed",
                        "text": "Wednesday"
                    },
                    {
                        "value": "thu",
                        "text": "Thursday"
                    },
                    {
                        "value": "fri",
                        "text": "Friday"
                    },
                    {
                        "value": "sat",
                        "text": "Saturday"
                    },
                    {
                        "value": "sun",
                        "text": "Sunday"
                    },
                ],
                timePickerOptions: {
                    format: 'hh:mm a', // https://momentjs.com/docs/#/displaying/
                    useCurrent: false,
                    minDate: false,
                    maxDate: false,
                    // tooltips: tooltipTranslate,
                    // locale: 'ua',
                    keyBinds: false
                },
                shiftsMaxCount: 10,
            }
        },

        components: {
            VueTelInput,
            customModalDialog,
            passwordValidation,
            w3wPopup,
            telegramBotPopup,
            timeZoneSelector,
            ModelSelect,
            datePicker,
        },

        async beforeMount() {
            this.reloadFromProfile()
            await this.fetchUserInfo()
            this.reloadFromProfile()
        },

        watch: {
            'profile.phone'(newValue) {
                this.$nextTick(() => {
                    this.$refs.phoneField.fieldClasses['md-focused'] = newValue.length > 0
                })
            },
            'profile.SendNotificationEach' (newValue) {
               this.profile.SendNotificationEach = newValue
                if(newValue !== '' && newValue != this.userInfo.setups.notifications.vote_count) this.updateProfileAlerts()
            },

            'changePass.newPassword'(item) {
                this.passwordValidationSettings.validation = item
            },
        },

        computed: {
            ...mapState({
                userInfo: state => state.auth.userInfo,
            }),

            ...mapGetters({
                isUserOwner: 'auth/isUserOwner',
                isUserOrgManager: 'auth/isUserOrgManager',
                isUserSiteManager: 'auth/isUserSiteManager',
                isCroLinked: 'auth/isCroLinked',
                isHubspotLinked: 'auth/isHubspotLinked',
            }),

            raAllSelected() {
                let allSelected = this.profile.rateAnalyzeGroups.filter((item) => !item.selected).length == 0
                return allSelected
            },
            raNothingSelected() {
                return this.profile.rateAnalyzeGroups.filter((item) => item.selected).length == 0
            },

        },

        methods: {

            ...mapActions({
                updateProfileAction: 'auth/updateProfile',
                updateShifts: 'auth/updateShifts',
                updateProfileTimezoneAction: 'auth/updateProfileTimezone',
                deleteAccountAction: 'owner/deleteAccount',
                fetchUserInfo: 'auth/fetchUserInfo',
                fetchNewPassword: 'auth/fetchNewPassword',
                resendEmail: 'auth/resendEmail',
                logoutRemote: 'auth/logout',
                fetchTelegramHash: 'auth/fetchTelegramHash',
                unlinkCroAction: 'auth/unlinkCro',
                unlinkHubspotAction: 'auth/unlinkHubspot',
            }),
            ...mapMutations({
                removeKeys: 'auth/removeKeys',
                setProgressBarTag: 'setProgressBarTag',
                setMessageModel: 'setMessageModel',
            }),

            reloadFromProfile(){
                this.profile.firstName = this.userInfo.first_name;
                this.profile.lastName = this.userInfo.last_name;
                this.profile.email = this.userInfo.contact_email;
                this.profile.phone = this.userInfo.phone;
                this.profile.timezone = this.userInfo.timezone
                this.profile.shiftsEnabled = this.userInfo.shifts_enabled
                this.profile.checkboxSms = this.userInfo.setups.notifications.channels.includes('sms')
                this.profile.checkboxEmail = this.userInfo.setups.notifications.channels.includes('email')
                this.profile.checkboxTelegram = this.userInfo.setups.notifications.channels.includes('telegram')
                this.profile.checkboxHappy = this.userInfo.setups.notifications.notified_votes.includes('happy')
                this.profile.checkboxSoSo = this.userInfo.setups.notifications.notified_votes.includes('ok') //todo then soso_votes3
                this.profile.checkboxSad = this.userInfo.setups.notifications.notified_votes.includes('sad')
                this.profile.checkboxServiceLog = this.userInfo.setups.notifications.notified_votes.includes('service_log')
                this.profile.checkboxDumpsters = this.userInfo.setups.notifications.notified_votes.includes('dumpsters')
                this.profile.checkboxGreasetraps = this.userInfo.setups.notifications.notified_votes.includes('greasetraps')
                this.profile.checkboxDumpstersShow = this.userInfo.setups.notifications.notify_dumpsters_show
                this.profile.checkboxGreasetrapsShow = this.userInfo.setups.notifications.notify_greasetraps_show
                this.profile.checkboxGoogleReviewAlerts = this.userInfo.setups.notifications.notified_votes.includes('google_reviews')
                this.profile.checkboxGoogleReviewAlertsShow = this.userInfo.setups.notifications.notify_google_reviews_show
                this.profile.smsExpanded = this.userInfo.setups.notifications.sms_expanded
                this.profile.SendNotificationEach = this.userInfo.setups.notifications.vote_count
                this.profile.disableNotifications = !this.userInfo.setups.notifications.enabled
                this.profile.detailsOnly = this.userInfo.setups.notifications.ai_assist
                this.profile.rateAnalyzeGroups = this.userInfo.setups.notifications.rate_analyze_groups
                this.profile.dailyReports = this.userInfo.setups.reports.daily_reports
                this.profile.weeklyReports = this.userInfo.setups.reports.weekly_reports
                this.profile.monthlyReports = this.userInfo.setups.reports.monthly_reports
                this.profile.showZeroVotes = this.userInfo.setups.views.show_zero_votes
                this.profile.useW3W = this.userInfo.setups.views.show_w3w
                this.profile.filterUnassignedQuestions = this.userInfo.setups.views.filter_unassigned_q
                this.profile.croIntegrationShow = this.userInfo.integrations.show_cro_settings
                this.profile.hubspotIntegrationShow = this.userInfo.integrations.show_hubspot_settings
                this.profile.shiftsSetupInitial = this.userInfo.shifts_setup
                this.parseShiftsInitial()
            },
            parseShiftsInitial() {
                console.debug(`parseShiftsInitial`)
                let shiftsSetup = JSON.parse(JSON.stringify(this.profile.shiftsSetupInitial))
                this.profile.shifts = shiftsSetup.shifts
                if(this.profile.shifts.length > 0) {
                    this.profile.shiftsDetailed = true
                    if (shiftsSetup.fixed_shift != null) {
                        this.profile.shiftsDetailed = false
                        let fixed = shiftsSetup.fixed_shift
                        let fixedParsed = {
                            from_time: fixed.from_time,
                            to_time: fixed.to_time,
                        }
                        let dowsFixed = []
                        this.dows.forEach(dow => {
                            dowsFixed.push({
                                label: dow.text,
                                value: dow.value,
                                enabled: fixed.dows.indexOf(dow.value) > -1,
                            })
                        })
                        fixedParsed.dows = dowsFixed
                        this.profile.shiftsSimple = fixedParsed
                    }
                } else {
                    this.profile.shiftsDetailed = false
                    this.resetSimpleShifts()
                }
            },
            resetSimpleShifts() {
                this.profile.shiftsSimple = {
                    from_time: '08:00',
                    to_time: '17:00',
                    dows: [
                        {
                            label: 'Monday',
                            value: 'mon',
                            enabled: true,
                        },
                        {
                            label: 'Tuesday',
                            value: 'tue',
                            enabled: true,
                        },
                        {
                            label: 'Wednesday',
                            value: 'wed',
                            enabled: true,
                        },
                        {
                            label: 'Thursday',
                            value: 'thu',
                            enabled: true,
                        },
                        {
                            label: 'Friday',
                            value: 'fri',
                            enabled: true,
                        },
                        {
                            label: 'Saturday',
                            value: 'sat',
                            enabled: false,
                        },
                        {
                            label: 'Sunday',
                            value: 'sun',
                            enabled: false,
                        },
                    ],
                }
            },

            onCloseAccount(){
                logAnalyticsEvent(`settings_close_acc_click`)
                this.customModalSettings = {
                    message: this.translate(this.userInfo.deletion ? 'SendRequestToRestore' : 'SendRequestToClose'),
                    onOkHandler: this.closeAccount.bind(null),
                    showCancelButton: true,
                    okButtonText: this.translate('yes'),
                    cancelButtonText: this.translate('no'),
                }

            },
            onCroClick(){
                if(this.isCroLinked) {
                    logAnalyticsEvent(`settings_cro_unlink_click`)
                    this.showUnlinkCroConfirmDialog()
                } else {
                    logAnalyticsEvent(`settings_cro_link_click`)
                    this.openCroAuthLink()
                }
            },
            openCroAuthLink() {
                let url = 'https://idp.crosoftware.com/oauth2/auth?' +
                    'response_type=code' +
                    '&state=' + this.userInfo.guid +
                    '&client_id=airvote_prod' +
                    '&scope=openid%20offline%20api' +
                    '&redirect_uri=https%3A%2F%2Fmy.air-vote.com%2Fauth%2Fcrosoftware%2Fcallback'
                console.debug(url)
                window.open(url, '_blank')
            },

            showUnlinkCroConfirmDialog() {
                this.customModalSettings = {
                    message: `Are you sure to unlink CRO account?`,
                    onOkHandler: this.unlinkCro.bind(),
                    showCancelButton: true,
                    okButtonText: `Unlink`,
                    cancelButtonText: `Cancel`
                }
            },

            async unlinkCro() {
                try {
                    this.setProgressBarTag({
                        show: true,
                        tag: 'unlinkCro'
                    })
                    await this.unlinkCroAction()
                    await this.fetchUserInfo()
                    this.setMessageModel({
                        msg: this.translate('settings_unlink_cro_success'),
                        duration: 1000
                    })
                } catch (e) {
                    this.showErrorModal(e.data.error.message, {
                        title: 'Error',
                        code: e.data.error.code
                    })
                } finally {
                    this.setProgressBarTag({
                        show: false,
                        tag: 'unlinkCro'
                    })
                }
            },

            onHubspotClick(){
                if(this.isHubspotLinked) {
                    logAnalyticsEvent(`settings_hubspot_unlink_click`)
                    this.showUnlinkHubspotConfirmDialog()
                } else {
                    logAnalyticsEvent(`settings_hubspot_link_click`)
                    this.openHubspotAuthLink()
                }
            },
            openHubspotAuthLink() {
                let url = `https://app-eu1.hubspot.com/oauth/authorize?` +
                `client_id=${encodeURIComponent(process.env.VUE_APP_HUBSPOT_CLIENT_ID)}` +
                `&scope=` + encodeURIComponent('crm.objects.deals.write') +
                `&state=` + encodeURIComponent(this.userInfo.guid) +
                `&redirect_uri=${encodeURIComponent(location.protocol + '//' + location.host + '/auth/hubspot/callback')}`
                console.debug(url)
                window.open(url, '_blank')
            },

            showUnlinkHubspotConfirmDialog() {
                this.customModalSettings = {
                    message: `Are you sure to unlink Hubspot account?`,
                    onOkHandler: this.unlinkHubspot.bind(),
                    showCancelButton: true,
                    okButtonText: `Unlink`,
                    cancelButtonText: `Cancel`
                }
            },

            async unlinkHubspot() {
                try {
                    this.setProgressBarTag({
                        show: true,
                        tag: 'unlinkHubspot'
                    })
                    await this.unlinkHubspotAction()
                    await this.fetchUserInfo()
                    this.setMessageModel({
                        msg: this.translate('settings_unlink_hubspot_success'),
                        duration: 1000
                    })
                } catch (e) {
                    this.showErrorModal(e.data.error.message, {
                        title: 'Error',
                        code: e.data.error.code
                    })
                } finally {
                    this.setProgressBarTag({
                        show: false,
                        tag: 'unlinkHubspot'
                    })
                }
            },

            returnToMain () {
                this.$router.push({name: 'OwnerPlaceManagement'})
            },

            async closeAccount(){
                const requested = this.userInfo.deletion ? true : false
                try {
                    await this.deleteAccountAction({requested})
                    logAnalyticsEvent(`settings_close_acc_req_success`)
                    await this.fetchUserInfo()
                } catch (e) {
                    logError('settings_close_acc_req_error', e.data.error.message || '')
                    this.showErrorModal(e.data.error.message, {
                        title: 'Error',
                        code: e.data.error.code
                    })
                }
            },
            async updateProfileInfo() {
                this.$v.profile.$touch()
                if (!this.$v.profile.$invalid) {
                    this.saveSpinner = true
                    const body = {
                        first_name: this.profile.firstName,
                        last_name: this.profile.lastName,
                        contact_email: this.profile.email,
                        phone: this.profile.phone,
                    }
                    try {
                        await this.updateProfile(body, 'info')
                        logAnalyticsEvent(`settings_save_info_success`)
                    } catch (e) {
                        logError('settings_save_info_error', e.data.error.message || '')
                    } finally {
                        this.saveSpinner = false
                    }
                } else {
                    logError('settings_save_acc_data_invalid', '')
                    this.saveDisable = true
                }
            },
            async updateProfileAnalytic() {
                const body = {
                    setups: {
                        views: {
                            show_zero_votes: this.profile.showZeroVotes,
                            show_w3w: this.profile.useW3W,
                            filter_unassigned_q: this.profile.filterUnassignedQuestions
                        }
                    }
                }
                try {
                    await this.updateProfile(body, 'setups')
                    logAnalyticsEvent(`settings_save_analytic_success`)
                } catch (e) {
                    logError('settings_save_analytic_error', e.data.error.message || '')
                }
            },
            onWithDetailsOnlyClick() {
                console.debug(`onWithDetailsOnlyClick: ${this.profile.detailsOnly}`)
                this.changeAllRateAnalyzeGroups(this.profile.detailsOnly)
                this.updateProfileAlerts()
            },
            onTimeZoneChangedSettings(tz) {
                console.debug(`onTimeZoneChangedSettings: ${tz}`)
                this.profile.timezone = tz
                this.updateProfileTimezone()
            },
            updateProfileAlerts: async function () {
                if(this.profile.SendNotificationEach == '') this.profile.SendNotificationEach = '1'
                if(this.profile.SendNotificationEach == '0') this.profile.SendNotificationEach = '1'
                const body = {
                    setups: {
                        notifications: {
                            enabled: !this.profile.disableNotifications,
                            sms_expanded: this.profile.smsExpanded,
                            vote_count: parseInt(this.profile.SendNotificationEach),
                            show_zero_votes: this.profile.showZeroVotes,
                            ai_assist: this.profile.detailsOnly && !this.raNothingSelected,
                            rate_analyze_groups: this.profile.rateAnalyzeGroups,
                        }
                    }
                }
                let channelsData = {
                    'sms': this.profile.checkboxSms,
                    'email': this.profile.checkboxEmail,
                    'telegram': this.profile.checkboxTelegram,

                }
                body.setups.notifications.channels = this.createSettingsArray(channelsData)
                let notifiedData = {
                    'happy': this.profile.checkboxHappy,
                    'ok': this.profile.checkboxSoSo,
                    'sad': this.profile.checkboxSad,
                    'service_log': this.profile.checkboxServiceLog,
                    'dumpsters': this.profile.checkboxDumpsters,
                    'greasetraps': this.profile.checkboxGreasetraps,
                    'google_reviews': this.profile.checkboxGoogleReviewAlerts,
                }
                body.setups.notifications.notified_votes = this.createSettingsArray(notifiedData)
                if(body.setups.notifications.channels.length == 0 || (body.setups.notifications.notified_votes.length == 0 && !body.setups.notifications.any_commented)) body.setups.notifications.enabled = false
                try {
                    await this.updateProfile(body, 'setups')
                    logAnalyticsEvent(`settings_save_alert_success`)
                } catch (e) {
                    logError('settings_save_alert_error', e.data.error.message || '')
                }
            },
            createSettingsArray(data) {
                let settings = []
                for (const [key, value] of Object.entries(data)) {
                    if(value) settings.push(key)
                }
                return settings
            },
            onChangeProfileReport() {
                this.updateProfileReports()
            },
            async updateProfileReports() {
                const body = {
                    setups: {
                        reports: {
                            daily_reports: this.profile.dailyReports,
                            weekly_reports: this.profile.weeklyReports,
                            monthly_reports: this.profile.monthlyReports
                        },
                    }
                }
                try {
                    await this.updateProfile(body, 'setups')
                    logAnalyticsEvent(`settings_save_report_success`)
                } catch (e) {
                    logError('settings_save_report_error', e.data.error.message || '')
                }
            },


            async updateProfile(body, type){
                    // this.saveSpinner = true;
                    try {
                        const response = await this.updateProfileAction( { body, type })
                        // this.$bvToast.toast(this.translate('savedSuccessfuly'), {
                        //     title: this.translate('Message'),
                        //     variant: 'success',
                        //     solid: true,
                        //     autoHideDelay: 1000
                        // })
                    } catch (e) {
                        this.showErrorModal(e.data.error.message, {
                            title: 'Error',
                            code: e.data.error.code
                        })
                        throw e
                    } finally {
                        // this.saveSpinner = false
                    }
            },
            async updateProfileTimezone() {
                    // this.saveSpinner = true;
                    try {
                        const response = await this.updateProfileTimezoneAction( { timezone: this.profile.timezone, })
                    } catch (e) {
                        this.showErrorModal(e.data.error.message, {
                            title: 'Error',
                            code: e.data.error.code
                        })
                    } finally {
                        // this.saveSpinner = false
                    }
            },

            checkValidation(){
                this.$v.profile.$touch()

                if (!this.$v.profile.$invalid) {
                    this.saveDisable = false
                } else {
                    this.saveDisable = true
                }
            },
            changePassword () {
                this.isActive = !this.isActive
            },

            async resendEmailAction () {
                try {
                    this.setProgressBarTag({
                        show: true,
                        tag: 'resendEmail'
                    })
                    const response = await this.resendEmail()
                    if (response.data.success) {
                        this.customModalSettings = {
                            icon: 'ic_allow.svg',
                            message: this.translate('bi_resend_email_success'),
                            showCancelButton: false,
                            okButtonText: this.translate('Ok'),
                        }
                    } else {
                        this.showErrorModal(response.data.error.message, {
                            title: 'Error',
                            code: response.data.error.code
                        })
                    }
                } catch (e) {
                    this.showErrorModal(e.data.error.message, {
                        title: 'Error',
                        code: e.data.error.code
                    })
                } finally {
                    this.setProgressBarTag({
                        show: false,
                        tag: 'resendEmail'
                    })
                }
            },

            async saveNewPassword () {
                let currentPassword = this.changePass.currentPassword
                let body = {
                    new_password: this.changePass.newPassword,
                }
                if(this.userInfo.has_password) body.actual_password = currentPassword
                try {
                    this.setProgressBarTag({
                        show: true,
                        tag: 'fetchNewPassword'
                    })
                    const response = await this.fetchNewPassword(body)
                    this.setMessageModel({
                        msg: this.translate('bi_password_change_success'),
                        duration: 1000
                    })
                    await this.fetchUserInfo()
                } catch (e) {
                    this.showErrorModal(e.data.error.message, {
                        title: 'Error',
                        code: e.data.error.code
                    })
                } finally {
                    this.setProgressBarTag({
                        show: false,
                        tag: 'fetchNewPassword'
                    })
                    this.changePass.currentPassword = ''
                    this.changePass.newPassword = ''
                    this.changePass.RetypeNewPassword = ''
                }
            },
            onInputPhoneField(value, obj) {
                this.currentPhoneCountry = `+${obj.country.dialCode}`
                this.$v.profile.phone.$touch()
                this.checkValidation()
            },

            onBlurPhoneField() {
                let validate = this.profile.phone.replace(/[' ']/g, '').replace(/-/g, '')
                if (isPhoneValid(validate)) {
                    this.$refs.phoneField.$el.classList.remove('md-invalid')
                } else {
                    this.$refs.phoneField.$el.classList.add('md-invalid')
                }
            },
            showPassword() {
                if(this.type === 'password') {
                    this.type = 'password-text'
                } else {
                    this.type = 'password'
                }
            },
            onPasswordFocus() {
                this.passwordValidationSettings.show = true
            },

            onPasswordFocusLost() {
                this.passwordValidationSettings.show = this.changePass.newPassword !== ''
            },
            showW3Wpopup() {
                this.w3wPopupSettings = {
                    show: true
                }
            },

            async logout() {
                logAnalyticsEvent('settings_logout_click')
                try {
                    await this.logoutRemote()
                } catch (error) {
                    console.debug('error', error)
                } finally {
                    this.removeKeys()
                    this.$store.commit('owner/setOwner', false)
                    this.$router.push('/sign-in')
                }
            },
            setupTelegramBotClick() {
                this.fetchTelegramHashAction()
            },
            async fetchTelegramHashAction () {
                try {
                    this.setProgressBarTag({
                        show: true,
                        tag: 'fetchTelegramHash'
                    })
                    const response = await this.fetchTelegramHash()
                    this.telegramBotPopupSettings = {
                        icon: 'ic_allow.svg',
                        title: this.translate('telegramPopupTitle'),
                        input: {
                            value: response.data.hash,
                            placeholder: `${response.data.hash}`,
                            disabled: true
                        },
                        hash: response.data.hash
                    }
                } catch (e) {
                    this.showErrorModal(e.data.error.message, {
                        title: 'Error',
                        code: e.data.error.code
                    })
                } finally {
                    this.setProgressBarTag({
                        show: false,
                        tag: 'fetchTelegramHash'
                    })
                }
            },

            onDetailedCustomizationCheckboxBeforeChanged() {
                console.debug(`onDetailedCustomizationCheckboxBeforeChanged`)
                if(!this.profile.shiftsDetailed) {
                    this.generateShiftsFromSimple()
                }
            },
            generateShiftsFromSimple() {
                console.debug(`generateShiftsFromSimple`)
                this.profile.shifts.length = 0
                this.profile.shiftsSimple.dows.forEach(dow => {
                    if(dow.enabled) {
                        let shift = {
                            from_dow: dow.value,
                            from_time: this.profile.shiftsSimple.from_time,
                            to_dow: dow.value,
                            to_time: this.profile.shiftsSimple.to_time,
                        }
                        this.profile.shifts.push(shift)
                    }
                })
            },
            onShiftFromTimeSelectorHidden(shift){
                console.debug(`onShiftFromTimeSelectorHidden`, shift)
            },
            onShiftFromTimeChanged(shift) {
                console.debug(`onShiftFromTimeChanged`, shift)
            },
            onShiftToTimeSelectorHidden(shift){
                console.debug(`onShiftToTimeSelectorHidden`, shift)
            },
            onShiftToTimeChanged(shift) {
                console.debug(`onShiftToTimeChanged`, shift)
            },
            onShiftRemoveClick(shift) {
                console.debug(`onShiftRemoveClick`, shift)
                const index = this.profile.shifts.indexOf(shift);
                this.profile.shifts.splice(index, 1);
            },
            onShiftAddClick() {
                console.debug(`onShiftAddClick`)
                if(this.profile.shifts.length >= this.shiftsMaxCount) {
                    this.showErrorModal("Maximum count of shifts added")
                    return
                }
                //todo check latest dow
                let shift = {
                    from_dow: 'mon',
                    from_time: '08:00',
                    to_dow: 'mon',
                    to_time: '17:00',
                }
                this.profile.shifts.push(shift)
            },
            async onSimpleShiftsResetClick() {
                this.parseShiftsInitial()
            },
            async onShiftsResetClick() {
                this.parseShiftsInitial()
            },
            async onShiftsSaveClick() {
                console.debug(`onShiftsSaveClick`)
                if(!this.profile.shiftsDetailed) {
                    this.generateShiftsFromSimple()
                }
                await this.saveShifts()
            },
            async saveShifts() {
                const body = {
                    shifts: this.profile.shifts.map(shift => {
                        return {
                            from_dow: shift.from_dow,
                            from_time: moment(shift.from_time, "hh:mm a").format('HH:mm'),
                            to_dow: shift.to_dow,
                            to_time: moment(shift.to_time, "hh:mm a").format('HH:mm'),
                        }
                    }),
                    enabled: this.profile.shiftsEnabled,
                }
                this.saveSpinner = true;
                try {
                    const response = await this.updateShifts( { body })
                    // this.$bvToast.toast("Shifts saved", {
                    //     title: "Success",
                    //     variant: 'success',
                    //     solid: true,
                    //     autoHideDelay: 300
                    // })
                } catch (e) {
                    this.showErrorModal(e.data.error.message, {
                        title: 'Error',
                        code: e.data.error.code
                    })
                } finally {
                    this.saveSpinner = false
                }
            },
            onMoveShiftUpClick(shift, index) {
                console.debug(`onMoveShiftUp`)
                if(!this.profile.shifts || index == 0) return
                this.profile.shifts.splice(index, 1)
                this.profile.shifts.splice(index - 1, 0, shift)
            },
            onMoveShiftDownClick(shift, index) {
                console.debug(`onMoveShiftUp`)
                if(!this.profile.shifts || (this.profile.shifts.length - 1) == index) return
                this.profile.shifts.splice(index, 1)
                this.profile.shifts.splice(index + 1, 0, shift)
            },
            signedInByAdmin() {
                return localStorage.getItem('originalCredentials') !== null
            },
            onRAImportantClick(item) {
                item.high_priority = !item.high_priority
                this.updateProfileAlerts()
            },
            onRateAnalyzeChangeAllClick(selectAll) {
                console.debug(`onRateAnalyzeChangeAllClick: ${selectAll}`)
                this.changeAllRateAnalyzeGroups(selectAll)
                this.updateProfileAlerts()
            },
            onRateAnalyzeItemCheckChanged(item, event) {
                console.debug(`onRateAnalyzeItemCheckChanged ${item.selected}`)
                console.debug(`event.target.checked ${event.target.checked}`)
                item.selected = event.target.checked
                this.updateProfileAlerts()
            },
            changeAllRateAnalyzeGroups(selectAll) {
                this.profile.rateAnalyzeGroups.forEach((item) => {
                    item.selected = selectAll
                    if(!selectAll) {
                        item.high_priority = false
                    }
                })
            },
        }

    }

</script>

<!--deprecated-->
<style>
    .manager-settings h6 {
        margin-top: 50px;
    }

    .manager-settings .photo {
        max-width: 120px;
        margin: 0 auto;
        border-radius: 50%;
        display: block;
        overflow: hidden;
    }
    .manager-settings .vue-tel-input {
        position: absolute;
        z-index: 2;
        border: none;
        width: 100%;
    }

    .manager-settings .vue-tel-input:focus {
        outline: none;
    }

    .manager-settings .vue-tel-input:focus-within {
        border: none;
        box-shadow: none;
    }

    .manager-settings .vti__input {
        background: none;
    }

    .manager-settings .vti__dropdown {
        top: -2px;
    }
    .vti__dropdown {
        outline: none !important;
        border: none;
    }

    .manager-settings .md-field.md-focused label,
    .manager-settings .md-field.md-has-value label {
        pointer-events: auto;
        top: 0;
        opacity: 0.8;
        font-family: Nunito;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 20px;
    }
    .md-field {
        display: flex;
        flex-direction: column-reverse;
    }

    .manager-settings .notifications input[type="number"] {
        width: 50px;
        margin: 0;
        text-align: center;
    }

    .manager-settings .notifications input[type="checkbox"] {
        margin-right: 10px;
    }


    .manager-settings .md-field.md-invalid .md-error {
        left: auto;
        right: 0;
    }
</style>
<!--/ deprecated-->
<style>

    .component-fade-enter-active, .component-fade-leave-active {
        /*transition: all .3s ease;*/
        transform: translateY(0px);
        opacity: 1;
        position: relative;
    }
    .component-fade-enter, .component-fade-leave-to
        /* .component-fade-leave-active до версии 2.1.8 */ {
        position: absolute;
        opacity: 0;
        transform: translateY(-50px);
    }

    #owner-panel .vti__dropdown-arrow {
        position: relative;
        left: 0;
        top: 50%;
        transform: translateY(-100%) rotate(45deg);
        width: 8px;
        height: 8px;
        border-bottom: 2px solid #2F2F2F;
        border-right: 2px solid #2F2F2F;
        color: transparent;
        /*margin-left: 4px;*/
    }

    .top-bar {
        display: flex;
        justify-content: space-between;
        align-items: baseline;
    }

    .manager-settings .top-bar p {
        color: #2F2F2F;
        font-size: 14px;
        letter-spacing: 0;
        line-height: 22px;
        margin: 0;
    }

    .manager-settings .top-bar button.btn-secondary:not(.primaryButton) {
        background-color: #2F2F2F;
        border-radius: 4px;
        font-weight: 500;
        /*padding-top: 11px;*/
        /*padding-bottom: 11px;*/
        min-width: 184px;
        /*margin-top: 10px;*/
    }

    .manager-settings .top-bar button.btn-secondary:not(.primaryButton) span {
        font-weight: 700;
        font-size: 14px;
        letter-spacing: 0;
        /*line-height: 18px;*/
        text-align: center;
    }

    .manager-settings .top-bar .dropdown-menu {
        box-shadow: 0 10px 11px 0 rgba(0,0,0,0.11);
        border: 0;
        padding: 0;
        width: 93%;
    }

    .manager-settings .top-bar .dropdown-menu .dropdown-item {
        text-decoration: none;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .dropdown-item.active, .dropdown-item:active {
        background-color: inherit;
    }
    .manager-settings .top-bar .dropdown-menu li {
        width: 100%;
        height: 50px;
        display: flex;
        align-items: center;
        margin: 0;
        text-align: center;
    }
    .returnBtn__wrapper {
        display: flex;
        cursor: pointer;
        width: 10%;
        margin-bottom: -15px;
        align-items: center;
    }
    .manager-settings {
        margin-top: 25px;
    }
    .returnBtn__icon {
        margin-right: 5px;
        color: #3F405C;
    }
    .returnBtn__text {
        color: #3F405C;
        font-weight: 700;
        font-family: 'Nunito';
        padding-top: 2px;
    }
    .notification__wrapper {
        display: flex;
        flex-direction: column;
    }
    .notification__content {
        padding-top: 10px;
    }

    .manager-settings .top-bar .dropdown-menu .dropdown-item span {
        font-weight: 500;
        font-size: 14px;
        /*line-height: 18px;*/
        color: #2F2F2F;
        padding: 0;
    }

    .manager-settings .top-bar .reverse button.btn-secondary {
        background: none;
        border: 2px solid #2F2F2F;
        color: #3F405C;
        margin-right: 15px;
    }

    .manager-settings .top-bar .left-carret button.btn-secondary span {
        padding-left: 20px;
        position: relative;
    }

    .manager-settings .top-bar .left-carret button.btn-secondary span:before {
        content: '';
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-75%) rotate(45deg);
        width: 10px;
        height: 10px;
        border-bottom: 2px solid #2F2F2F;
        border-right: 2px solid #2F2F2F;
    }

    .manager-settings button.btn {
        /*padding-top: 11px;*/
        /*padding-bottom: 11px;*/
        padding: 12px 16px;
        margin-top: 20px;
    }

    .manager-settings .top-bar .dropdown {
        right: 0;
    }
    .tz-selector {
        max-width: 350px;
    }
    .tz-selector-wrapper {
        margin-top: 16px;
    }
    .tz-selector-wrapper .lbl {
        font-weight: normal;
        font-size: 14px;
        line-height: 20px;
    }
    .notificationBtn {
        margin-top: 20px;
    }
    .notificationBtn.customized-alerting-cb {
        margin-top: 12px;
    }
    .notificationBtn__checkbox {
        position: absolute;
        z-index: -1;
        opacity: 0;
    }
    .notificationBtn__checkbox+label {
        display: inline-flex;
        align-items: center;
        user-select: none;
        font-family: Nunito;
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
    }
    .notificationBtn__checkbox+label::before {
        content: '';
        display: inline-block;
        height: 20px;
        width: 20px;
        flex-shrink: 0;
        flex-grow: 0;
        border: 2px solid black;
        border-radius: 0.25em;
        margin-right: 0.5em;
        background-repeat: no-repeat;
        background-position: center center;
        background-size: 50% 50%;
    }
    .notificationBtn__checkbox:checked+label::before {
        border-color: #3F405C;
        background-color: #3F405C;
        background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3e%3c/svg%3e");
    }
    .sendNotification-string {
        font-weight: 600 !important;
        font-size: 16px;
        line-height: 24px;
        font-style: normal;
        font-family: Nunito;
        margin-top: 5px;
        margin-bottom: 16px;
    }
    .sendNotification-string.active {
        display: none;
    }

/*  dropdowns  */

    .active-field .w3w__checkbox .custom-control-label {
        margin-right: 10px;
    }

</style>

<style scoped>

    .saving-strip {
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        height: 26px;
        background: #389700;
        z-index: 999999999;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        gap: 8px;
        color: white;
    }

    .active-field.other {
        margin-bottom: 30px;
    }

    .w3w__checkbox {
        display: flex;
        margin-top: 10px;
    }
    .w3w__info {
        cursor: pointer;
    }
    .unassigned-question {
        cursor: pointer;
        margin-top: 10px;
    }

    .dropdown-content {
        margin-top: 16px;
    }

    .dropdown-content .item {
        margin: 0 0 24px;
        width: 100%;
        -webkit-box-shadow: 0 5px 11px 0 rgba(0, 0, 0, 0.11);
        box-shadow: 0 5px 11px 0 rgba(0, 0, 0, 0.11);
        position: relative;
    }
    .item__wrapper {
        border-radius: 4px;
        background-color: #FFFFFF;
        padding: 29px 30px 18px;
    }
    .other_settings .report-content {
        margin-top: 0;
    }

    .other_settings .report-content.int_button {
        margin-bottom: 24px;
    }

    .dropdown-content .item .title {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .dropdown-content .item .title img {
        margin-right: 17px;
    }

    .settings-title {
        color: #2F2F2F;
        font-size: 16px;
        line-height: 22px;
        cursor: pointer;
        font-family: Nunito;
        font-style: normal;
        font-weight: bold;
        font-size: 18px;
        line-height: 28px;
    }
    .dropdown-content .item h3 {
        color: #2F2F2F;
        font-size: 16px;
        line-height: 22px;
        cursor: pointer;
        margin: 0 0 7px;
    }

    .dropdown-content .item i {
        position: absolute;
        left: -16px;
        top: 10px;
        transform: translateY(-50%);
    }

    .dropdown-content .item h3 span {
        font-weight: 700;
        font-size: 17px;
    }


    .dropdown-content .item .description {
        color: #2F2F2F;
        letter-spacing: 0;
        line-height: 22px;
        font-family: Nunito;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 22px;
        padding-right: 15px;
    }
    .dropdown-content .item .description.description_details_only {
        margin-left: 25px;
    }

    /*content*/

    .dropdown-content .content {
        margin-bottom: 24px;
        margin-left: 38px;
        margin-top: -5px;
    }

    .dropdown-content .photo-section {
        display: flex;
        align-items: baseline;
        margin-bottom: 24px;
    }

    .dropdown-content .photo-section .img {
        width: 96px;
        height: 96px;
        overflow: hidden;
        border-radius: 50%;
        margin-right: 16px;
    }

    .dropdown-content .photo-section .img img {
        min-width: 96px;
        min-height: 96px;
    }


    .dropdown-content .input-section {
        max-width: 600px;
    }

    .input-section > div:not(:last-child) {
        padding-bottom: 16px;
    }
    input::-webkit-calendar-picker-indicator {
        display: none;
    }

    .dropdown-content .input-section .name {
        display: flex;
        justify-content: space-between;
    }

    .dropdown-content .input-section .name .md-field {
        width: calc(50% - 8px);
    }


    .dropdown-notification__checkbox {
        opacity: .5;
        cursor: no-drop;
        pointer-events: none;
    }
    .disable-notification {
        opacity: .5;
        cursor: no-drop;
    }

    .disable-notification > div {
        pointer-events: none;
    }

    .notification-section {
        grid-gap: 8px;
    }
    .notification-section > div {
        display: flex;
        align-items: center;
    }

    .notification-section > div:nth-child(odd) span,
    .notification-section > div:nth-child(even) label {
        color: #2F2F2F;
        font-size: 14px;
        line-height: 22px;
    }

    .notification-section > div:nth-child(odd) span {
        font-style: normal;
        font-weight: 600 !important;
        font-size: 15px;
        line-height: 20px;
        padding-left: 4px;
    }

    .notification-section > div:nth-child(even) label {
        margin-bottom: 0;
        margin-right: 19px;
    }

    .notification-section > div:nth-child(even) label span {
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        font-family: Nunito;
        padding-left: 5px;
    }

    .active-field__number {
        font-size: 14px;
        max-width: 25px;
        background: none;
        border: 0;
        outline: none!important;
        margin-bottom: 8px;
    }
    .active-field__number.active {
        border-bottom: 2px solid #3F405C;
        max-width: 45px;
    }
    .dropdown-content ul {
        position: relative;
    }


        /*short-info*/

    .dropdown-content .short-info {
        margin-left: 36px;
        margin-top: 3px;
    }
    .title__wrapper {
        display: flex;
    }
    .short-info__first {
        display: flex;
    }
    .last-name__wrapper {
        margin-left: 205px;
    }
    .short-info__title {
        font-family: Nunito;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 20px;
    }
    .first-name div{
        font-family: Nunito;
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
        word-break: break-all;
    }
    .last-name div{
        font-family: Nunito;
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
        word-break: break-all;
    }
    .short-info__email-wrapper {
        margin-top: 25px;
        position: relative;
        overflow: hidden;
    }
    .short-info__email-content {
        display: flex;
        align-items: center;
    }
    .short-info__email {
        margin-top: 3px;
    }
    .short-info__email a {
        font-family: Nunito;
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
        color: #2f2f2f;
        text-decoration: none;
        outline: none;
        word-break: break-all;
    }
    .email-resend__btn {
        font-family: Nunito;
        font-style: normal;
        font-weight: bold;
        font-size: 16px;
        line-height: 24px;
        padding: 10px 15px;
        border: 2px solid #3F405C;
        border-radius: 6px;
        width: 250px;
        text-align: center;
        margin-top: 9px;
        cursor: pointer;
    }
    .short-info__phone-wrapper {
        margin-top: 23px;
    }
    .short-info__phone {
        margin-top: 2px;
    }
    .short-info__phone a {
        font-family: Nunito;
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
        color: #2f2f2f;
        text-decoration: none;
        outline: none;
    }
    .short-info__password-wrapper {
        margin-top: 25px;
        display: flex;
        flex-direction: column;
        width: 225px;
    }
    .password__save-btn {
        background-color: #3F405C;
        padding: 12px 54px;
        margin-right: 63px;
        font-family: Nunito;
        font-style: normal;
        font-weight: bold;
        font-size: 16px;
        line-height: 24px;
        color: #ffffff;
        border-radius: 6px;
        cursor: pointer;
    }
    .password__cansel-btn {
        font-family: Nunito;
        cursor: pointer;
        font-style: normal;
        font-weight: bold;
        font-size: 16px;
        line-height: 24px;
        color: #3F405C
    }
    .password-change {
        text-align: center;
        font-family: Nunito;
        font-style: normal;
        font-weight: bold;
        font-size: 16px;
        line-height: 24px;
        padding: 9px;
        border: 2px solid #3F405C;
        box-sizing: border-box;
        border-radius: 6px;
        margin-top: 4px;
        cursor: pointer;
    }
    .def-btn {
        width: 225px;
        text-align: center;
        font-family: Nunito;
        font-style: normal;
        font-weight: bold;
        font-size: 16px;
        line-height: 24px;
        padding: 9px;
        border: 2px solid #3F405C;
        box-sizing: border-box;
        border-radius: 6px;
        margin-top: 10px;
        cursor: pointer;
    }
    .profile-section {
        margin-left: 32px;
        margin-top: 16px;
    }
    .md-field .md-input {
        font-family: Nunito;
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
        color: #2f2f2f;
    }
    .md-field:after {
        height: 2px;
        background-color: #3F405C;
    }
    .md-field.active:after {
        height: 2px;
        background-color: #3F405C;
    }
    .action-btn__wrapper {
        height: 96px;
        background: #F3F3F3;
        border-radius: 6px;
        width: 100%;
    }
    .alert__image {
        margin-bottom: 22px;
    }
    .btn_image_ {
        width: 24px;
        height: 24px;
        margin-right: 8px
    }
    .report__image {
        align-self: start;
        margin-right: 13px !important;
    }
    .analytic-image {
        margin-bottom: 33px;
    }
    .active-field__checkbox-list {
        margin-left: 20px;
    }
    .cb-generic {
        min-height: 28px;
    }
    .ra-select-all-wrapper {
        margin-top: 6px;
        display: flex;
        flex-direction: row;
        margin-bottom: 6px;
    }
    .ra-select-all {
        cursor: pointer;
        font-weight: 500;
    }
    .ra-select-all:hover {
        text-decoration: underline;
    }
    .description_checkbox-list {
        margin-left: 32px;
        display: flex !important;
        flex-direction: column;
    }
    .ai_group_cbs {
        display: flex;
        flex-direction: row;
        font-size: 14px;
        line-height: 22px;
    }
    .ai_group_important {
        background-color: #C2C2C2;
        height: 20px;
        border-radius: 10px;
        color: white;
        align-self: center;
        display: flex;
        margin-left: 8px;
        cursor: pointer;
    }
    .ai_group_important.selected {
        background-color: #FF9797;
    }
    .ai_group_important:hover>.lbl {
        display: block;
    }
    /*.ai_group_important:hover {*/
    /*    background-color: #FF9797;*/
    /*}*/
    /*.ai_group_important.selected:hover {*/
    /*    background-color: #FF9797;*/
    /*}*/
    .ai_group_important .excl {
        width: 20px;
        height: 20px;
        text-align: center;
    }
    .ai_group_important .lbl {
        margin-right: 10px;
        display: none;
    }
    .additional_checkboxes {
        display: flex !important;
        flex-direction: column;
        align-items: flex-start !important;
    }
    .blocks-divider {
        width: 100%;
        height: 1px;
        background: rgba(199, 199, 199, 0.5);
        margin-top: 10px;
        margin-bottom: 10px;
    }
    .shifts-wrapper {
        display: flex;
        flex-direction: column;
        gap: 12px;
    }
    .shift-item {
        display: flex;
        flex-direction: row;
        column-gap: 12px;
    }
    .shift-item .dow-selector {
        max-width: 120px;
    }
    .shift-item .time-selector {
        max-width: 85px;
    }
    .time-selector-wrapper .time-selector {
        max-width: 85px;
    }
    .time-selector-wrapper {
        display: flex;
        flex-direction: row;
        gap: 10px;
    }
    .shift-arrow {
        display: flex;
        align-items: center;
    }
    .shift-item .ic-block-action {
        width: 20px;
        height: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 2px;
        cursor: pointer;
    }
    .shift-item .block-icon .empty {
        height: 16px;
    }
    .shift-item .ic-block-action:hover {
        background: #e2e2e2;
    }
    .shift-item .block-icon {
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    .shift-remove {
        width: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
        cursor: pointer;
    }
    .shift-remove:hover {
        background: rgba(255, 0, 0, 0.15);
    }
    .shift-remove:active {
        background: #ff9a9a;
    }
    .shift-remove img {
        max-width: 20px;
    }
    .add-shift {
        width: 100px;
        height: 38px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid rgba(199, 199, 199, 0.5);
        cursor: pointer;
        margin-top: 12px;
        border-radius: 4px;
    }
    .add-shift:hover {
        background: #2F9E001F;
    }
    .add-shift:active {
        background: #2F9E0059;
    }
    .shifts-btns {
        display: flex;
        flex-direction: row;
        gap: 10px;
    }
    .reset-shifts {
        width: 100px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        margin-top: 12px;
        border-radius: 4px;
        color: #424242;
        background: #eaeaea;
    }
    .reset-shifts:hover {
        background: #c6c6c6;
    }
    .save-shifts {
        width: 100px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        margin-top: 12px;
        border-radius: 4px;
        color: white;
        background: #3F405C;
    }
    .save-shifts:hover {
        background: #323453FF;
    }
    .save-shifts:active {
        background: #3F405C;
    }

    .active-field__comment {
        margin-top: 5px;
    }

    .edit__btn {
        cursor: pointer;
        background: #3F405C;
        border-radius: 6px;
        padding: 12px 21px;
        display: flex;
        align-items: center;
        height: 48px;
        margin-top: 8px;
    }
    .edit__btn.active {
        display: none;
    }
    .edit__btn-icon {
        margin-right: 8px !important;
    }
    .edit__btn-text {
        font-family: Nunito;
        font-style: normal;
        font-weight: bold;
        font-size: 16px;
        line-height: 24px;
        color: white;
    }
    .save__wrapper {
        width: 100%;
        background: #F3F3F3;
        margin-bottom: 24px;
        border-radius: 6px;
        display: flex;
        align-items: center;

    }
    .save__content {
        display: flex;
        align-items: center;
        margin-left: 64px;
        margin-top: 24px;
    }
    .content__save-btn {
        background-color: #3F405C;
        padding: 12px 54px;
        margin-right: 63px;
        font-family: Nunito;
        font-style: normal;
        font-weight: bold;
        font-size: 16px;
        line-height: 24px;
        color: #ffffff;
        border-radius: 6px;
        cursor: pointer;
    }
    .setup_telegram {
        background-color: #3F405C;
        padding: 5px 45px;
        margin-right: 63px;
        font-family: Nunito;
        font-style: normal;
        font-weight: bold;
        font-size: 16px;
        line-height: 24px;
        color: #ffffff;
        border-radius: 6px;
        cursor: pointer;
        color: white !important;
    }
    .email-verified__check {
        display: flex;
        align-items: center;
        margin-left: 50px;
    }
    .email-verified__check img {
        width: 16px !important;
        height: 16px !important;
        margin-right: 7px !important;
    }
    .email-check__text {
        color: #F84900;
        font-family: Nunito;
        font-size: 14px;
        letter-spacing: 0;
        line-height: 18px;
    }
    .analytic-description {
        margin-top: 10px;
    }
    .analytic-description__btn {
        font-family: Nunito;
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
        color: #1976D2;
        cursor: pointer;
    }
    .description__btn-text {
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
        border-bottom: 1px #1976D2 dashed;
    }
    .analytic-description__content {
        background: rgba(74, 145, 250, 0.1);
        border-radius: 6px;
        margin-top: 17px;
        display: none;
    }
    .analytic-description__content.active {
        display: block;
    }
    .analytic-description__wrapper {
        padding: 16px 30px;
        display: flex;
    }
    .analytic-description__icon {
        margin-right: 21px;
    }
    .analytic-description__title {
        font-family: Nunito;
        font-style: normal;
        font-weight: 700;
        font-size: 14px;
        line-height: 22px;
        color: #2F2F2F;
    }
    .analytic-description__subtitle {
        font-family: Nunito;
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 22px;
        color: #2F2F2F;
        padding-bottom: 25px;
    }



    .dropdown-content .short-info span {
        font-size: 14px;
    }

    .dropdown-content .short-info img {
        width: 40px;
        height: 40px;
        overflow: hidden;
        border-radius: 50%;
        margin-right: 14px;
    }

    .dropdown-content .grid {
        display: flex;
        flex-direction: column;
        margin-top: 10px;
    }

    /*.dropdown-content .grid.notification-section div,*/
    /*.dropdown-content .grid.notification-section div a {*/
    /*    color: #2F2F2F;*/
    /*}*/

    /*.dropdown-content .grid div:nth-child(odd) {*/
    /*    font-weight: 700;*/
    /*    margin-right: 27px;*/
    /*}*/
    .email-verified__wrapper {
        display: flex;
        align-items: center;
    }
    .email-verified__icon {
        margin-right: 5px;
    }
    .email-verified__text {
        color: #F84900;
        font-family: Nunito;
        font-size: 14px;
        letter-spacing: 0;
        line-height: 22px;
        font-weight: normal;
    }
    .mail {
        position: relative;
    }
    .reset-email {
        text-decoration: none;
        outline: none;
        position: absolute;
        top: 20px;
        right: -35%;
        width: 200px;
        color: #1976D2;
        font-family: Montserrat;
        font-size: 14px;
        font-weight: 600;
        letter-spacing: 0;
        line-height: 18px;
    }
    .reset-email:hover {
        cursor: pointer;
        text-decoration: none;
        outline: none;
        color: #1976D2;
    }
    .password-change__content {
        display: flex;
    }
    .password-change__text {
        color: #1976D2;
        font-family: Montserrat;
        font-size: 14px;
        font-weight: 600;
        letter-spacing: 0;
        line-height: 18px;
        cursor: pointer;
    }
    .password-custom {
        margin-left: 24px;
        width: 360px;
        position: relative;
        margin-bottom: 50px;
    }
    .password-custom:last-child {
        margin-bottom: 40px;
    }
    .pssword-change__wrapper {
        display: flex;
        align-items: center;
    }
    .password-change__btn {
        display: flex;
        align-items: center;
        justify-content: space-around;
        border-radius: 4px;
        background-color: #2F2F2F;
        padding: 12px 16px;
        width: max-content;
        cursor: pointer;
    }
    .password-btn__text {
        color: #FFFFFF;
        font-family: Montserrat;
        font-size: 14px;
        font-weight: 600;
        letter-spacing: 0;
        line-height: 18px;
    }
    .password-content__wrapper  {
        display: none;
    }
    .password-content__wrapper.active {
        display: block !important;
    }
    /*Password Modal*/
    .modal-overlay {
        position: fixed;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        background: rgba(0, 0, 0, .5);
        z-index: 9999;
        display: none;
    }
    .modal-overlay.active {
        display: block;
    }
    .modal-window {
        width: 408px;
        border-radius: 6px;
        box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.12);
        background-color: #ffffff;
        margin: 50px auto;
        position: relative;
    }
    .modalHeader-cross {
        position: absolute;
        top: 20px;
        right: 22px;
        width: 18px;
        height: 18px;
        cursor: pointer;
    }
    .modalHeader-title {
        font-family: Nunito;
        font-style: normal;
        font-weight: bold;
        font-size: 18px;
        line-height: 28px;
        color: #2f2f2f;
        text-align: center;
        padding-top: 58px;
        padding-bottom: 15px;
    }
    .show-password {
        position: absolute;
        right: 10px;
        top: 20px;
    }
    .md-field label {
        font-family: Nunito;
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
        color: #6D6D6D;
        padding-bottom: 5px;
        top: 17px;
    }
    .md-button .md-ripple {
        display: block !important;
    }
    .manager-settings .md-field.md-focused label, .manager-settings .md-field.md-has-value label {
        opacity: 1;
    }
    .modalFooter-btn {
        display: flex;
        margin-left: 24px;
        align-items: center;
        padding-bottom: 25px;
    }
    .report-title {
        font-weight: normal !important;
        font-size: 14px !important;
        line-height: 20px !important;
        margin-bottom: -10px;
    }
    .report-content {
        margin-left: 36px;
        margin-top: 23px;
    }
    .no_subtitle-content {
        margin-top: 12px !important;
    }
    .password-icons {
        margin-top: -40px;
        margin-left: 25px;
        flex-direction: column;
    }

    .password-icon-row .input-icon {
        margin-top: 0;
        padding-right: 5px;
    }

    .password-icon-row {
        display: flex;
        color: #3F405C;
        font-weight: 700;
        font-size: 16px;
        line-height: 22px;
        font-family: 'Nunito';
    }

    .password-icon-row .icon-active {
        color: #36BC00;
    }

    .password-icon-row .icon-inactive {
        color: #FD4315;
    }
    .content-text__wrapper {
        margin-bottom: -10px;
        margin-top: 24px;
    }
    .content-text {
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 20px;
    }

    .settings-cb {
        margin-top: 4px;
    }
    .settings-cb span {
        font-weight: 600;
    }

    @media  screen and (max-width: 475px) {
        .active-field label {
            width: 100%;
        }
    }

</style>

<style scoped>

    @media screen and (max-width: 1000px) {
        .top-bar {
            flex-direction: column;
            margin-top: 0;
        }

        .dropdown-content .photo-section {
            flex-direction: column;
            align-items: center;
        }

        .dropdown-content .photo-section .img {
            margin-bottom: 30px;
        }

        .dropdown-content .input-section .name {
            width: 100%;
            flex-direction: column;
        }

        .dropdown-content .input-section .name .md-field:last-child {
            margin-top: 20px;
        }

        .dropdown-content .input-section .name .md-field {
            width: 100%;
        }

        .dropdown-content .grid {
            grid-template-columns: auto;
        }

        /*.dropdown-content .grid div {*/
        /*    display: inline-block;*/
        /*}*/

    }
    @media screen and (max-width: 768px) {
        .reset-email {
            top: 52px;
            left: 60px;
        }
        .dropdown-content .item .title {
            flex-direction: column;
            align-items: start;
            margin-bottom: 15px;
        }
        .edit__btn {
            margin-left: 35px;
            margin-top: 15px;
        }
        .short-info__first {
            flex-direction: column;
        }
        .short-info__email-content {
            flex-direction: column;
            align-items: start;
        }
        .email-verified__check {
            margin-left: 0;
            margin-top: 10px;
        }
        .last-name__wrapper {
            margin-left: 0;
        }
        .dropdown-content .content {
            margin-left: 33px;
        }
        .profile-section {
            margin-left: 0;
        }
        .md-field.active:after {
            width: auto;
        }

    }
    @media screen and (max-width: 426px) {
        .password-change__content {
            flex-direction: column;
        }
        .email-resend__btn {
            width: auto;
        }
        .email-verified__wrapper {
            margin-top: 5px;
            margin-bottom: 5px;
            display: flex;
            align-items: center;
        }
        .short-info__first {
            flex-direction: column;
            align-items: start;
        }
        .last-name__wrapper {
            margin: 0;
        }
        .first-name__wrapper {
            margin-bottom: 15px;
        }
        .password-change {
            width: auto;
        }
        .active-field__comment {
            margin-right: 0 !important;
        }
        .save__content {
            margin-left: 0;
            flex-direction: column;
            justify-content: center;
            width: 100%;
        }
        .content__save-btn {
            margin-right: 0;
        }
        .content__cancel-btn {
            margin-top: 25px;
        }
        .active-field label {
            margin-right: 0 !important;
            width: 100% !important;
        }
        .active-field__checkbox-list {
            margin-left: 0;
        }
        .notification-section > div:nth-child(odd) span {
            padding-left: 0;
        }
        .modalFooter-btn {
            flex-direction: column;
            margin-left: 0;
            justify-content: center;
        }
        .password__save-btn {
            margin-right: 0;
            margin-bottom: 25px;
        }
        .setup_telegram {
            padding: 5px 15px;
            margin-top: 10px;
            text-align: center;
        }
    }
    @media screen and (max-width: 375px) {
        .email-verified__text {
            font-size: 12px;
        }
        .modal-window {
            width: 350px;
        }
        .password-custom {
            width: 300px;
        }

    }
    @media screen and (max-width: 320px) {
        .reset-email {
            font-size: 12px;
        }
        .email-verified__wrapper {
            top: -15px;
            left: 17px;
        }
        .modal-window {
            width: 295px;
        }
        .password-custom {
            width: 250px;
        }
        .content__save-btn {
            padding: 12px 30px;
        }
        .dropdown-content .short-info {
            margin-left: 0;
        }

    }


</style>
